import Axios from "axios";
import {
    SET_SHARED_USERS_LIST,
    UNSET_SHARED_USERS_LIST,
    SET_SHARED_WITH_ME_LIST,
    UNSET_SHARED_WITH_ME_LIST
 } from "@/store/mutation-types";

import { 
    getSharedUsersList,
    getSharedWithMeList,
    shareDocuments, 
} from "@/store/api";

const state = {
    getSharedUsersList: [],
    getSharedWithMeList: []
};

const getters = {
    getSharedUsersList(state) {
        return state.getSharedUsersList;
    },
    getSharedWithMeList(state) {
        return state.getSharedWithMeList;
    },
};

const mutations = {
    [SET_SHARED_USERS_LIST](state, data) {
        state.getSharedUsersList = data;
    },
    [UNSET_SHARED_USERS_LIST](state) {
        state.getSharedUsersList = [];
    },
    [SET_SHARED_WITH_ME_LIST](state, data) {
        state.getSharedWithMeList = data;
    },
    [UNSET_SHARED_WITH_ME_LIST](state) {
        state.getSharedWithMeList = [];
    },
};

const actions = {
    getSharedUsersList({ commit }, data) {
        return new Promise((resolve, reject) => {
            commit("SET_LOADING", {color: "primary"});
            Axios.get(getSharedUsersList, { params: data})
                .then(function (response) {
                    commit('SET_SHARED_USERS_LIST', response.data.data)
                    resolve(response.data.data);
                })
                .catch(function (error) {
                    commit('UNSET_SHARED_USERS_LIST')
                    reject(error);
                })
                .then((always) => {
                    commit("UNSET_LOADING")
                });
        });
    },

    getSharedWithMeList({ commit }, data) {
        return new Promise((resolve, reject) => {
            commit("SET_LOADING", {color: "primary"});
            Axios.get(getSharedWithMeList, { params: data})
                .then(function (response) {
                    commit('SET_SHARED_WITH_ME_LIST', response.data.data)
                    resolve(response.data.data);
                })
                .catch(function (error) {
                    commit('UNSET_SHARED_WITH_ME_LIST')
                    reject(error);
                })
                .then((always) => {
                    commit("UNSET_LOADING")
                });
        });
    },

    shareDocuments({ commit }, data) {
        commit("SET_LOADING", {color: "primary"});
        return new Promise((resolve, reject) => {
            Axios.post(shareDocuments, data)
                .then(function (response) {
                    resolve(response.data);
                })
                .catch(function (error) {
                    reject(error);
                })
                .then((always) => {
                    commit("UNSET_LOADING");
                });
        });
    },

};

export default {
    state,
    getters,
    actions,
    mutations,
};
